import { PageInfoDto } from '@/dto';

export let dataItem = [
  		'id',
  'guid',
  'companyId',
  'number',
  'name',
  'isPrimary',
  'physicalAddress1',
  'physicalAddress2',
  'physicalCity',
  'physicalState',
  'physicalZipcode',
  'mailingAddress1',
  'mailingAddress2',
  'mailingCity',
  'mailingState',
  'mailingZipcode',
  'shippingAddress1',
  'shippingAddress2',
  'shippingCity',
  'shippingState',
  'shippingZipcode',
  'email',
  'phone',
  'fax',
  'active',

];

export let dataInfo = [
  		'id',
  'guid',
  'companyId',
  'number',
  'name',
  'isPrimary',
  'physicalAddress1',
  'physicalAddress2',
  'physicalCity',
  'physicalState',
  'physicalZipcode',
  'mailingAddress1',
  'mailingAddress2',
  'mailingCity',
  'mailingState',
  'mailingZipcode',
  'shippingAddress1',
  'shippingAddress2',
  'shippingCity',
  'shippingState',
  'shippingZipcode',
  'email',
  'phone',
  'fax',
  'createdByUserId',
  'modifiedByUserId',
  'dateCreated',
  'dateModified',
  'active',

];

export class listDto {
  constructor(results) {
    this.items = results.items.map(item => new gridDto(item));
    this.pageInfo = new PageInfoDto(results.paging);
  }
}

export class dataItemDto {
  constructor(data = {}) {
    dataItem.forEach(key => (this[key] = data[key] || null));
  }
}

export class gridDto {
  constructor(data = {}) {
    dataInfo.forEach(key => (this[key] = data[key] || null));
  }
}
